import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.traffic.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-traffic-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.traffic.access/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageTrafficAccessComponent implements OnInit {
    public email: string = '';
    public password: string = '';
    public errorMsg: string = '';
    public loading: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const token = sessionStorage.getItem('traffic_token');
        if (token) {
            try {
                const res = await this.service.request.post('/api/auth/verify', { token });
                if (res.code === 200) {
                    this.service.href('/main');
                    return;
                }
            } catch (e) { }
            sessionStorage.removeItem('traffic_token');
        }
        await this.service.render();
    }

    public async login() {
        this.errorMsg = '';
        this.loading = true;
        await this.service.render();

        try {
            const res = await this.service.request.post('/api/auth/login', {
                email: this.email,
                password: this.password,
            });
            if (res.code === 200) {
                sessionStorage.setItem('traffic_token', res.data.token);
                this.service.href('/main');
                return;
            }
            this.errorMsg = res.data?.message || '로그인에 실패했습니다.';
        } catch (e) {
            this.errorMsg = '서버 오류가 발생했습니다.';
        }
        this.loading = false;
        await this.service.render();
    }

    public onKeydown(event: any) {
        if (event.key === 'Enter') {
            this.login();
        }
    }
}

export default PageTrafficAccessComponent;